module.exports = __webpack_public_path__ + "img/device-default.c08c5b22.png";